<template>
    <section class="o-section">
        <h2 class="c-account__subtitle">Bienvenue</h2>
        <div class="o-text">
            <h3>{{ currentUser.firstname }} {{ currentUser.lastname }}</h3>
        </div>
    </section>
    <section id="abonnements" class="o-section o-section-large">
        <h2 class="c-account__title o-title-5">
            <!-- <?php svg('account', '-ico-lg'); ?> -->
            <svg aria-hidden="true" focusable="false" class="o-ico -ico-lg">
                <use xlink:href="/app/themes/baserock/assets/img/sprite.svg?v=cfe82883f6882d10e6#account"></use>
            </svg>
            Abonnements
        </h2>
        <div v-for="(pass, index) in passes" :key="index" class="c-cart__item">
            <div class="c-cart__item-header">                                   
                <div class="c-cart__product-name">
                    <h3 class="c-account-item__name">Laissez-passer {{ pass.type }}</h3>
                    <p v-if="pass.type == 'Individuel'" class="c-account-item__description">{{ pass.name }}</p>
                </div>
                <div class="c-cart__product-btn__wrapper">
                    <div class="c-cart__product-btn__wrapper">
                        <a class="c-cart__product-btn-delete" target="_blank" :href="'/laissez-passer/?token='+pass.code">
                            <svg aria-hidden="true" focusable="false" class="o-ico -icon-cart">
                                <use xlink:href="/app/themes/baserock/assets/img/sprite.svg?v=5dea11d359b55f8dfd#download"></use>
                            </svg>
                        </a>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="!passes || passes.length == 0" class="c-block-warning u-color-1-darker">
            <div class="c-block-warning__inner">
                <div class="c-block-warning__inner__icon">
                    <svg aria-hidden="true" focusable="false" class="o-ico ">
                        <use xlink:href="/app/themes/baserock/assets/img/sprite.svg?v=cfe82883f6882d10e6#warning"></use>
                    </svg>
                </div>
                <div class="o-text">
                    <p class="-is-text-large"><strong>Laisser-passer Estival</strong><br>Votre abonnement est expiré</p>
                </div>
            </div>
        </div>
    </section>
    <section v-if="hasFamilyMembership" id="abonnementsMembre" class="o-section o-section-large">
        <h2 class="c-account__title o-title-5">
            <!-- <?php svg('account', '-ico-lg'); ?> -->
            <svg aria-hidden="true" focusable="false" class="o-ico -ico-lg">
                <use xlink:href="/app/themes/baserock/assets/img/sprite.svg?v=cfe82883f6882d10e6#account"></use>
            </svg>
            Membres de l'abonnement familial
        </h2>
        <div v-for="(member, index) in members" :key="index" class="c-cart__item" :class="{'-is-open': member.edit}">
            <div class="c-cart__item-header">                                   
                <div class="c-cart__product-name">
                    <h3 class="c-account-item__name">{{ member.name }}</h3>
                    <p class="c-account-item__description">{{ member.type }}</p>
                </div>
                <div class="c-cart__product-btn__wrapper">
                    <button @click="editMember(index)" class="c-cart__product-btn-expend">
                        <!-- <?php svg('arrow-up-cart', '-icon-cart -icon-cart-arrow'); ?> -->
                        <svg aria-hidden="true" focusable="false" class="o-ico -icon-cart -icon-cart-arrow">
                            <use xlink:href="/app/themes/baserock/assets/img/sprite.svg?v=5dea11d359b55f8dfd#arrow-up-cart"></use>
                        </svg>
                        <!-- <?php svg('inscription', '-icon-cart -icon-cart-edit'); ?> -->
                        <svg aria-hidden="true" focusable="false" class="o-ico -icon-cart -icon-cart-edit">
                            <use xlink:href="/app/themes/baserock/assets/img/sprite.svg?v=5dea11d359b55f8dfd#inscription"></use>
                        </svg>
                    </button>
                    <button class="c-cart__product-btn-delete" @click="deleteMember(index)">
                        <!-- <?php svg('trash', '-icon-cart'); ?> -->
                        <svg aria-hidden="true" focusable="false" class="o-ico -icon-cart">
                            <use xlink:href="/app/themes/baserock/assets/img/sprite.svg?v=5dea11d359b55f8dfd#trash"></use>
                        </svg>
                    </button>
                </div>
            </div>
            <div v-if="member.edit" class="c-cart__item-detail">
                <div class="c-cart__item-detail__inner">
                    <div class="c-cart-form">
                        <h4 class="o-title-5">Informations sur le membre</h4>
                        <form class="o-form " data-module="FocusLabel">
                            <div class="o-form__row">
                                <div class="o-form__group">
                                    <input @change="changeMember" class="o-input" type="text" id="name" name="Nom" :class="{'-input-filled' : member.name }" v-model="member.name" required>
                                    <label class="o-label" for="name">Nom</label>
                                </div>
                                <div class="o-form__group">
                                    <label class="sr-only" for="age">Type</label>
                                    <div class="o-select__wrap">
                                        <select @change="changeMember" class="o-select" v-model="member.type" id="type" name="Type" required>
                                            <option value="Type" disabled selected>Type</option>
                                            <option value="Enfant">Enfant</option>
                                            <option value="Adulte">Adulte</option>
                                        </select>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>

        <div @click="addMember()" class="c-cart__pay-button">
            <span aria-label="Ajouter un enfant" class="o-button -button-alt">
                <span class="o-button__text">Ajouter un membre</span> 
                <span class="sr-only">Ajouter un membre</span>
                <svg aria-hidden="true" focusable="false" class="o-ico -icon-cart -icon-cart-arrow">
                    <use xlink:href="/app/themes/baserock/assets/img/sprite.svg?v=5dea11d359b55f8dfd#more"></use>
                </svg>
            </span>
        </div>

    </section>

    <section id="historique" class="o-section o-section-large">
        <h2 class="c-account__title o-title-5">
            <!-- <?php svg('historique', '-ico-lg'); ?> -->
            <svg aria-hidden="true" focusable="false" class="o-ico -ico-lg">
                <use xlink:href="/app/themes/baserock/assets/img/sprite.svg?v=cfe82883f6882d10e6#historique"></use>
            </svg>
            Historique d’achat
        </h2>
        <!--Card history-->
        <div class="c-account-historique">
            <div v-if="isEmpty(invoices)" class="c-cart__item">
                <div class="c-cart__item-header">
                    <div class="c-cart__product-name">
                        <p class="c-cart__product__information">Aucune commande</p>
                    </div>
                </div>
            </div>
            <div v-for="invoice in invoices" :key="invoice.invoice_number" class="c-cart__item">
                <div class="c-cart__item-header">
                    <div class="c-cart__product-name">
                        <h3 class="c-cart__product__name">Commande #{{ invoice.invoice_number }}</h3>
                        <p class="c-cart__product__information"></p>
                        <p class="c-cart__product__price">{{ formatMoney(invoice.cart_data.total) }}</p>
                        <p class="c-cart__product__date">{{ invoice.order_date}}</p>
                    </div>
                    <div class="c-cart__product-btn__wrapper">
                        <a class="c-cart__product-btn-delete" target="_blank" :href="'/commande/?token='+invoice.cart_token">
                            <svg aria-hidden="true" focusable="false" class="o-ico -icon-cart">
                                <use xlink:href="/app/themes/baserock/assets/img/sprite.svg?v=5dea11d359b55f8dfd#download"></use>
                            </svg>
                        </a>
                    </div>
                </div>
            </div>
        </div>
        <!--Button load more-->
        <div v-if="loadMore" class="">
            <div class="c-account__load-more">
                <div class="o-button__container">
                    <button :disabled="isLoading" @click="getInvoices()" class="o-button o-button-cart" type="submit">
                        <span class="o-button__text">Charger plus</span>
                        <span class="sr-only">Charger plus</span>
                    </button>
                </div>
            </div>
        </div>
    </section>
</template>
<script>
import axios from 'axios';
export default {
    name: 'DashboardHome',
    data: function () {
        return {
            invoices: [],
            page: 1,
            loadMore: false,
            isLoading: true,
            members: [],
            hasFamilyMembership: false,
        }
    },
    props: {
        currentUser: {
            type: Object,
            required: true
        }
    },
    methods: {
        getPasses(){
            let params = {
                _wpnonce: window.ajax_var.nonce
            }
            axios.get('/wp-json/pass/v1/passes', { params })
                .then(response => {
                    this.passes = response.data
                    //Foreach passes check if type is Familial
                    this.passes.forEach((pass) => {
                        if(pass.type == 'Familial'){
                            this.hasFamilyMembership = true
                            this.getMembers()
                        }
                    })
                })
                .catch(error => {
                    console.log(error)
                })
        },
        getInvoices(){
            let params = {
                _wpnonce: window.ajax_var.nonce,
                page: this.page,
            }

            axios.defaults.headers.common['Content-Type'] = 'application/json'
            axios.defaults.headers.common['X-WP-Nonce'] = window.ajax_var.nonce
            axios.get('/wp-json/stereostore/v1/invoices', { params })
                .then(response => {
                    this.invoices = this.invoices.concat(response.data.invoices)
                    this.loadMore = response.data.load_more
                    this.page++
                    this.isLoading = false
                })
                .catch(error => {
                    console.log(error)
                    this.isLoading = false
                })
        },
        isEmpty(obj) {
            return Object.keys(obj).length === 0;
        },
        formatMoney(value) {
            let language = 'fr';
            let currency = 'CAD';
            var formatter = new Intl.NumberFormat(language, {
                style: 'currency',
                currency: currency,
                currencyDisplay: 'narrowSymbol'
            });
            return formatter.format(value);
        },
        getMembers(){
            let params = {
                _wpnonce: window.ajax_var.nonce
            }
            axios.get('/wp-json/pass/v1/members', { params })
                .then(response => {
                    this.members = response.data
                })
                .catch(error => {
                    console.log(error)
                })
        },
        addMember(){
            this.members.forEach((member, i) => {
                this.members[i].edit = false
            })

            this.members.push({
                name: '',
                type: '',
                edit: true
            })
        },
        deleteMember(index){
            this.members.splice(index, 1)
            this.changeMember()
        },
        editMember(index){
            if(this.members[index].edit == true){
                this.members[index].edit = false
            } else {
                this.members.forEach((member, i) => {
                    this.members[i].edit = false
                })
                this.members[index].edit = true
            }
        },
        updateMembers(){
            let params = {
                _wpnonce: window.ajax_var.nonce,
                members: this.members
            }
            axios.post('/wp-json/pass/v1/members', params)
                .then(response => {
                    this.members = response.data
                })
                .catch(error => {
                    console.log(error)
                })
        },
        changeMember(){
            let valid = true
            if(this.members.length == 0){
                valid = false
            }
            this.members.forEach((member) => {
                if(member.name == '' || member.type == ''){
                    valid = false
                }
            })

            if(valid){
                this.updateMembers()
            }
        }
    },
    mounted() {
        this.getInvoices();
        this.getPasses();
    }
}
</script>